import React from 'react'

const Carieer = () => {
  return (
    <div>Carieer</div>
  )
}

export default Carieer